import { render, staticRenderFns } from "./SetMaxBindNumberModal.vue?vue&type=template&id=4c48a93c&scoped=true"
import script from "./SetMaxBindNumberModal.vue?vue&type=script&lang=js"
export * from "./SetMaxBindNumberModal.vue?vue&type=script&lang=js"
import style0 from "./SetMaxBindNumberModal.vue?vue&type=style&index=0&id=4c48a93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48a93c",
  null
  
)

export default component.exports